import { Form, Input } from 'antd';

export function InputField({
  placeholder = '',
  required = false,
  inputProps = undefined,
  rules = [],
  disabled,
  ...props
}) {
  return (
    <Form.Item
      rules={[{ required, message: `กรุณากรอก${props.label}` }, ...rules]}
      noStyle={inputProps?.type === 'hidden'}
      {...props}
    >
      <Input {...inputProps} placeholder={placeholder || `กรอก${props.label}`} disabled={disabled} />
    </Form.Item>
  );
}
